import { Checkbox, CheckboxProps } from "@mantine/core";
import { FieldRenderProps } from "react-final-form";
import { GenericInput } from "../../models/generic";
import { InputWrapper } from "./styles";
import { FC, ChangeEvent, ReactNode } from "react";

export interface CheckboxInputProps
  extends Omit<FieldRenderProps<boolean>, "input">,
    CheckboxProps {
  afterChange?: (value: boolean, field: string) => void;
  input: GenericInput<boolean>;
  variant?: "primary" | "secondary";
  label?: string | ReactNode;
}

export const CheckboxInput: FC<CheckboxInputProps> = ({
  input,
  meta = {},
  label,
  afterChange,
  disabled,
  variant = "primary",
  ...other
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    input.onChange(event.currentTarget.checked);
    if (afterChange && typeof afterChange === "function") {
      afterChange(event.currentTarget.checked, input.name || "");
    }
  };

  const hasError = meta?.invalid && meta?.submitFailed;

  return (
    <InputWrapper hasError={hasError} variant={variant}>
      <Checkbox
        label={label}
        disabled={disabled}
        checked={input.value}
        onChange={handleChange}
        {...other}
      />
    </InputWrapper>
  );
};

export default CheckboxInput;
